import { isTrustedCheckoutPostMessageOrigin } from '@/src/listings/common/monitoring/checkout/checkout-post-message';

export function getReportEventMessageAllowedOrigins(
  iframeSrc: string,
  pageOrigin: string = typeof window !== 'undefined' ? window.location.origin : '',
): readonly string[] {
  if (!iframeSrc || !pageOrigin) {
    return Object.freeze([]);
  }

  try {
    return Object.freeze([new URL(iframeSrc, pageOrigin).origin]);
  } catch {
    return Object.freeze([]);
  }
}

export function isTrustedReportEventPostMessageOrigin(
  origin: string,
  iframeSrc: string | null,
  pageOrigin?: string,
): boolean {
  if (!iframeSrc) {
    return false;
  }

  return isTrustedCheckoutPostMessageOrigin(origin, getReportEventMessageAllowedOrigins(iframeSrc, pageOrigin));
}
